var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0467 13.5198C15.1907 13.6912 15.2607 13.9128 15.2413 14.1357C15.2219 14.3587 15.1147 14.5649 14.9434 14.7088C14.772 14.8528 14.5504 14.9228 14.3275 14.9034C14.1045 14.884 13.8983 14.7768 13.7544 14.6055C12.7918 13.4594 11.0959 12.0939 8.4943 12.0939C6.46297 12.0939 4.59477 12.9855 3.23422 14.6055C3.09026 14.7768 2.88412 14.884 2.66114 14.9034C2.43816 14.9228 2.21662 14.8528 2.04524 14.7088C1.87386 14.5649 1.7667 14.3587 1.74731 14.1357C1.72793 13.9128 1.79792 13.6912 1.94188 13.5198C2.85856 12.4127 4.03458 11.5493 5.3654 11.0062C4.53784 10.3556 3.93369 9.46314 3.63701 8.45312C3.34033 7.4431 3.36589 6.36572 3.71013 5.3709C4.05436 4.37609 4.70015 3.51332 5.55763 2.90267C6.4151 2.29202 7.44161 1.96387 8.4943 1.96387C9.54699 1.96387 10.5735 2.29202 11.431 2.90267C12.2885 3.51332 12.9342 4.37609 13.2785 5.3709C13.6227 6.36572 13.6483 7.4431 13.3516 8.45312C13.0549 9.46314 12.4508 10.3556 11.6232 11.0062C12.9541 11.5491 14.1302 12.4126 15.0467 13.5198ZM8.4943 10.4064C9.16181 10.4064 9.81434 10.2085 10.3694 9.83762C10.9244 9.46677 11.357 8.93966 11.6124 8.32296C11.8678 7.70626 11.9347 7.02766 11.8045 6.37298C11.6742 5.71829 11.3528 5.11692 10.8808 4.64492C10.4088 4.17292 9.80742 3.85148 9.15273 3.72126C8.49805 3.59103 7.81945 3.65787 7.20275 3.91331C6.58605 4.16876 6.05894 4.60134 5.68809 5.15636C5.31724 5.71137 5.1193 6.3639 5.1193 7.03141C5.12023 7.92623 5.47611 8.78413 6.10884 9.41687C6.74158 10.0496 7.59948 10.4055 8.4943 10.4064Z",
    fill: "#C72611"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8945 8.36914L17.281 10.7556",
    stroke: "#C72611",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2812 8.36914L14.8948 10.7556",
    stroke: "#C72611",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/UserPlus.98b63ae75e332d330ba8da14f5c5295a.svg";
export { ForwardRef as ReactComponent };